import React from "react"
import { Link } from "gatsby"
import { Featured } from "./featuredproducts-styles"

const FeaturedProductsByCategory = ({cats, parentName}) => {
  return (
    <Featured>
      <h2>
        <span>{parentName}</span>
      </h2>
      <div className="featureditems">
        {cats.map((cat, ind) => (<div className="item">
          
              <Link to={cat.link}>
                <img src={cat.img} alt="" />
                <h3>{cat.name}</h3>
              </Link>
          </div>))}
        </div>
    </Featured>
  )
}

export default FeaturedProductsByCategory
